module.exports = __webpack_public_path__ + "img/wz1.173db302.png";